import { useEffect, useState } from "react";
import "./TestimonialGrid.css";
import axios from "axios";
import SectionTitle from "../../../../components/SectionTitle/SectionTitle";
import { Avatar, Skeleton } from "@mantine/core";

const TestimonialGrid = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [isLoading, setIsLoading] = useState(false)


    const fetchTestimonials = async () => {
        try {
            setIsLoading(true)
            const { data } = await axios.get(
                `${process.env.REACT_APP_BACKEND_SERVER}/info/testimonies`
            );

            const formattedResponse = data.map((testimonial) => {
                return {
                    name: `${testimonial.name}`,
                    avatar: testimonial?.user?.profilePicture || testimonial.profilePicture,
                    text: testimonial.review,
                    video_url: testimonial?.video_url,
                    id: testimonial._id,
                    academicUnit: {
                        name: testimonial?.academicUnit?.comercialInformation?.name,
                        type: testimonial?.academicUnit?.type
                    }
                };
            })
            setTestimonials(formattedResponse?.slice(0, 3));
        } catch (error) {
            console.error("Error fetching testimonials data:", error);

        } finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const SkeletonWrapper = () => {
        return <>
            <Skeleton animate h='250px' w='100%' />
            <Skeleton animate h='250px' w='100%' />
            <Skeleton animate h='250px' w='100%' />
        </>
    }

    return (
        <section className="testimonials section-wrapper">
            <div className="section-inner">

                <SectionTitle upText="Te cuentan ellos" downText="Lo que significa ser de FORVET" />

                <div className="testimonials-grid">
                    {isLoading && <SkeletonWrapper />}
                    {(!isLoading && testimonials) && testimonials?.map(item => {

                        return <div key={item.id} className={`testimonial-card ${item.video_url ? "testimonial-card--video" : ""}`}>
                            {item.video_url
                                ? <video
                                        src={item.video_url}
                                        controls
                                        className="testimonial-card--video-tag"
                                        frameBorder="0"
                                        allowFullScreen
                                    />
                                : <div className="tc-quote">"{item.text}"</div>}

                            <div className="tc-author">
                                <Avatar
                                    src={item.avatar}
                                    alt={item.name}
                                    w={44}
                                    h={44}
                                />

                                <div>
                                    <div className="tc-name">{item.name}</div>
                                    {/* <div className="tc-detail">Clínica de pequeños animales · Guayaquil, Ecuador</div> */}
                                    <div className="tc-detail">{item.academicUnit.type ? `${item?.academicUnit?.type} · ` : ""}  {item?.academicUnit.name}</div>

                                </div>
                            </div>
                        </div>
                    })}

                </div>
            </div>

        </section>
    )


};

export default TestimonialGrid;